(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["block_bundle_price"] && !Shopify.designMode) return;
  try {
    if (!window.bundleInit) {
window.bundleInit = true;
document.addEventListener('click', async (e) => {
const btn = e.target.closest('.bundle-add-btn');
if (!btn) return;
const bundle = btn.closest('[data-bundle]');
const dataEl = bundle.querySelector('.bundle-data');
if (!dataEl) return;
const items = JSON.parse(dataEl.dataset.items);
// Safety check
const hasSoldOut = items.some(item => !item.available);
if (hasSoldOut) {
    alert('Some items are sold out');
    return;
}
btn.classList.add('loading');
try {
    await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        items: items.map(item => ({
        id: item.id,
        quantity: 1
        }))
    })
    });
    import('@theme/events').then(({ CartUpdateEvent }) => {
    const cartDrawer = document.querySelector('cart-drawer-component');    
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
    const event = new CartUpdateEvent(cart, 'manual-trigger', {
        itemCount: cart.item_count,
        source: 'fad-refresh',
        sections: {}
    });
    document.dispatchEvent(event);
    if (cartDrawer?.hasAttribute('auto-open')) {
        cartDrawer.open();
    }
    });
});
} catch (err) {
    console.error('Bundle error:', err);
}
btn.classList.remove('loading');
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_collection_products"] && !Shopify.designMode) return;
  try {
    function initSlider(id) {
    const slider = document.getElementById('slider-' + id);
    if (!slider) return;
    const track = document.getElementById('track-' + id);
    const prev = slider.querySelector('.collection-slider-prev');
    const next = slider.querySelector('.collection-slider-next');
    const dotsWrap = document.getElementById('dots-' + id);
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed) || 3000;
    let index = 0;
    const slides = track.children;
    function getPerRow() {
      const style = getComputedStyle(slider.parentElement);

      if (window.innerWidth >= 1366) {
        return parseInt(
          style.getPropertyValue('--per-row-desktop')
        ) || 1;
      }

      if (window.innerWidth >= 768) {
        return parseInt(
          style.getPropertyValue('--per-row-tablet')
        ) || 1;
      }

      return parseInt(
        style.getPropertyValue('--per-row-mobile')
      ) || 1;
    }
    function go(i) {
      const perRow = getPerRow();
      const pages = Math.ceil(slides.length / perRow);
      const maxIndex = (pages - 1) * perRow;
      if (i < 0) i = 0;
      if (i > maxIndex) i = maxIndex;
      index = i;
      const slide = slides[index];
      if (!slide) return;
      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth',
      });
      updateDots();
    }

    if (prev) prev.onclick = () => go(index - getPerRow());
    if (next) next.onclick = () => go(index + getPerRow());
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const perRow = getPerRow();
      const pages = Math.ceil(slides.length / perRow);
      for (let i = 0; i < pages; i++) {
        let b = document.createElement('button');
        b.onclick = () => go(i * perRow);
        dotsWrap.appendChild(b);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      const perRow = getPerRow();
      const page = Math.round(index / perRow);
      dotsWrap.querySelectorAll('button').forEach((d, i) => {
        d.classList.toggle('active', i === page);
      });
    }

    if (autoplay) {
      setInterval(() => {
        go(index + getPerRow());
      }, speed);
    }
    let isDown = false;
    let startX;
    let scrollLeft;
    track.addEventListener('pointerdown', (e) => {
      isDown = true;
      startX = e.pageX;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('pointerup', () => (isDown = false));
    track.addEventListener('pointerleave', () => (isDown = false));
    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const walk = e.pageX - startX;
      track.scrollLeft = scrollLeft - walk;
    });
    buildDots();
    updateDots();
    window.addEventListener('resize', () => {
      buildDots();
      updateDots();
    });
  }
  document.querySelectorAll('.slider_block, .collection_block_slider').forEach((el) => {
    initSlider(el.dataset.id);
  });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.slider_block, .collection_block_slider').forEach((el) => {
      initSlider(el.dataset.id);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_marquee"] && !Shopify.designMode) return;
  try {
    function initMarquee(block) {
  if (block.marqueeInit) return;
  block.marqueeInit = true;

  const track = block.querySelector(".marquee-track");
  const loop = block.querySelector(".marquee-loop");

  let speedDesktop = parseFloat(block.dataset.speed) || 1;
  let speedMobile = parseFloat(block.dataset.speedM) || 1;

  let reverse = block.dataset.reverse === "true";
  let pauseHover = block.dataset.hover === "true";
  let drag = block.dataset.drag === "true";
  let dup = block.dataset.dup === "true";

  let pos = 0;
  let lastTime = 0;
  let isPaused = false;
  let isDown = false;
  let startX = 0;

  let loopSize = 0;
  let speed = 0;



  /* ---------------- SPEED ---------------- */

  function getSpeed() {
    speed =
      window.innerWidth < 768
        ? speedMobile
        : speedDesktop;
  }



  /* ---------------- DUPLICATE ---------------- */

    function buildLoop() {
      track.innerHTML = "";

      const base = loop.cloneNode(true);
      track.appendChild(base);

      /* measure AFTER render */
      const baseWidth = base.getBoundingClientRect().width;
      const containerWidth = block.getBoundingClientRect().width;

      /* fallback safety */
      if (!baseWidth || !containerWidth) return;

      /* how many copies needed (MAX 2–3 only) */
      const required = Math.ceil((containerWidth * 2) / baseWidth);

      for (let i = 0; i < required; i++) {
        const clone = loop.cloneNode(true);
        track.appendChild(clone);
      }

      loopSize = baseWidth;
    }


  /* ---------------- ANIMATION ---------------- */

    function frame(time) {

      if (!lastTime) lastTime = time;

      const delta = time - lastTime;

      lastTime = time;

      if (!isPaused && !isDown) {

        const move = (speed * delta) / 50;

        pos += reverse ? move : -move;

        /* ✅ smooth infinite using modulo */

        if (loopSize > 0) {
          pos = pos % loopSize;
        }

        track.style.transform =
          `translate3d(${pos}px,0,0)`;
      }

      requestAnimationFrame(frame);
    }


  /* ---------------- HOVER ---------------- */

  if (pauseHover) {
    block.addEventListener("mouseenter", () => {
      isPaused = true;
    });

    block.addEventListener("mouseleave", () => {
      isPaused = false;
    });
  }

  /* ---------------- INIT ---------------- */

  function init() {
    getSpeed();
    buildLoop();
    lastTime = 0;
  }

  init();

  requestAnimationFrame(frame);
}



/* ---------- INIT ---------- */

  document.querySelectorAll('[id^="marquee-"]').forEach((container) => {
    initMarquee(container);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_product"] && !Shopify.designMode) return;
  try {
    function initProductScript(sectionId) {
    //console.log(sectionId)
    const section = document.getElementById(sectionId);
    if (!section) return;

    /* -------------------------
       HELPERS
    -------------------------- */
    const $ = (sel, parent = section) => parent?.querySelector(sel);
    const $$ = (sel, parent = section) => parent ? [...parent.querySelectorAll(sel)] : [];
    const shopCurrency = section.dataset.currency;
    const shopLocale = section.dataset.locale;
    const formatMoney = (cents) => {
        const rate = Shopify?.currency?.rate || 1;
        const converted = (cents / 100);
        return new Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active,
        }).format(converted);
    };

    /* -------------------------
       GALLERY
    -------------------------- */
    function initGallery() {
      const gallery = $('.custom-product-gallery');
      if (!gallery) return;

      /*
      * The settings/classes are on the parent
      * .product_media-wrapper
      */
      const mediaWrapper =
        gallery.closest('.product_media-wrapper');

      const isCarousel =
        mediaWrapper?.classList.contains('enabled_media_carousel') ||
        gallery.classList.contains('enabled_media_carousel');

      const isThumbVertical =
        mediaWrapper?.hasAttribute('data-thumb-vertical') ||
        gallery.hasAttribute('data-thumb-vertical');

      /* -------------------------
        MAIN GALLERY
      -------------------------- */

      const mainGallery =
        $('.gallery-main', gallery);

      const mainItems =
        $$('.gallery-media-item', gallery);

      /* -------------------------
        THUMBNAILS
      -------------------------- */

      const thumbs =
        $$('.gallery-thumb', gallery);

      const track =
        $('.gallery-thumbs-track', gallery);

      const wrapper =
        $('.gallery-thumbs-wrapper', gallery);

      const thumbPrev =
        $('.thumb-prev', gallery);

      const thumbNext =
        $('.thumb-next', gallery);

      /* -------------------------
        MAIN ARROWS
      -------------------------- */

      const mainPrev =
        $('.main-prev', gallery);

      const mainNext =
        $('.main-next', gallery);

      if (!mainItems.length) return;

      let currentIndex = 0;
      let currentTranslate = 0;

      /* =========================================================
        MAIN SLIDE
      ========================================================= */

      function goToMainSlide(index, smooth = true) {

        if (!mainGallery || !mainItems.length) return;

        currentIndex =
          (index + mainItems.length) %
          mainItems.length;

        const target =
          mainItems[currentIndex];

        if (!target) return;

        /*
        * CAROUSEL MODE
        *
        * Scroll the actual .gallery-main
        */
        if (isCarousel) {

          const left =
            target.offsetLeft;

          const top =
            target.offsetTop;

          mainGallery.scrollTo({
            left: left,
            top: top,
            behavior: smooth ? 'smooth' : 'auto'
          });

        } else {

          /*
          * Normal non-carousel mode
          */
          mainItems.forEach((item, i) => {

            item.classList.toggle(
              'is-active',
              i === currentIndex
            );

            const video =
              item.querySelector('video');

            if (video && i !== currentIndex) {
              video.pause();
            }

          });

        }

        /*
        * Update thumbnail active state
        */
        thumbs.forEach((thumb, i) => {

          thumb.classList.toggle(
            'is-active',
            i === currentIndex
          );

        });

        /*
        * Keep active thumbnail visible
        */
        scrollThumbIntoView();
      }

      /* =========================================================
        THUMB CLICK
      ========================================================= */

      thumbs.forEach((thumb, index) => {

        thumb.addEventListener('click', () => {

          goToMainSlide(index, true);

        });

      });

      /* =========================================================
        MAIN PREVIOUS
      ========================================================= */

      mainPrev?.addEventListener('click', () => {

        goToMainSlide(
          currentIndex - 1,
          true
        );

      });

      /* =========================================================
        MAIN NEXT
      ========================================================= */

      mainNext?.addEventListener('click', () => {

        goToMainSlide(
          currentIndex + 1,
          true
        );

      });

      /* =========================================================
        THUMBNAIL TRANSLATE
      ========================================================= */

      function setThumbTranslate(value) {

        if (!track) return;

        currentTranslate = value;

        if (isThumbVertical) {

          track.style.transform =
            `translateY(${currentTranslate}px)`;

        } else {

          track.style.transform =
            `translateX(${currentTranslate}px)`;

        }

        /*
        * Update arrow state whenever
        * thumbnail position changes.
        */
        updateThumbArrows();
      }

      /* =========================================================
        SYNC VERTICAL THUMBNAIL HEIGHT
      ========================================================= */

      function syncVerticalThumbHeight() {

        if (
          !isThumbVertical ||
          !mainGallery ||
          !wrapper
        ) {
          return;
        }

        const mainHeight =
          mainGallery.clientHeight;

        if (!mainHeight) {
          return;
        }

        /*
        * Make the thumbnail viewport
        * exactly the same height as
        * the main gallery.
        */
        wrapper.style.height =
          `${mainHeight}px`;

        /*
        * Make sure the wrapper does not
        * grow because of its content.
        */
        wrapper.style.maxHeight =
          `${mainHeight}px`;

        /*
        * Ensure the track itself can
        * contain all thumbnails.
        */
        if (track) {
          track.style.height = 'max-content';
        }
      }

      /* =========================================================
        THUMBNAIL SIZE
      ========================================================= */

      function getThumbContainerSize() {

        if (!wrapper) {
          return 0;
        }

        return isThumbVertical
          ? wrapper.clientHeight
          : wrapper.clientWidth;
      }

      function getThumbTrackSize() {

        if (!track) {
          return 0;
        }

        return isThumbVertical
          ? track.scrollHeight
          : track.scrollWidth;
      }

      function getMaxThumbTranslate() {

        const containerSize =
          getThumbContainerSize();

        const trackSize =
          getThumbTrackSize();

        return Math.min(
          0,
          containerSize - trackSize
        );
      }

      /* =========================================================
        UPDATE THUMB ARROWS
      ========================================================= */

      function updateThumbArrows() {

        if (!thumbPrev && !thumbNext) {
          return;
        }

        /*
        * If there is no track/wrapper,
        * disable both arrows.
        */
        if (!track || !wrapper) {

          if (thumbPrev) {
            thumbPrev.disabled = true;
            thumbPrev.classList.add('is-disabled');
            thumbPrev.setAttribute(
              'aria-disabled',
              'true'
            );
          }

          if (thumbNext) {
            thumbNext.disabled = true;
            thumbNext.classList.add('is-disabled');
            thumbNext.setAttribute(
              'aria-disabled',
              'true'
            );
          }

          return;
        }

        const maxTranslate =
          getMaxThumbTranslate();

        /*
        * No overflow means there is
        * nowhere to scroll.
        */
        const hasOverflow =
          maxTranslate < 0;

        /*
        * At the beginning.
        */
        const atStart =
          currentTranslate >= 0;

        /*
        * At the end.
        */
        const atEnd =
          currentTranslate <= maxTranslate;

        /*
        * Previous
        */
        if (thumbPrev) {

          const disabled =
            !hasOverflow || atStart;

          thumbPrev.disabled =
            disabled;

          thumbPrev.classList.toggle(
            'is-disabled',
            disabled
          );

          thumbPrev.setAttribute(
            'aria-disabled',
            String(disabled)
          );
        }

        /*
        * Next
        */
        if (thumbNext) {

          const disabled =
            !hasOverflow || atEnd;

          thumbNext.disabled =
            disabled;

          thumbNext.classList.toggle(
            'is-disabled',
            disabled
          );

          thumbNext.setAttribute(
            'aria-disabled',
            String(disabled)
          );
        }
      }

      /* =========================================================
        CLAMP THUMB TRANSLATE
      ========================================================= */

      function clampThumbTranslate() {

        const maxTranslate =
          getMaxThumbTranslate();

        if (currentTranslate > 0) {
          currentTranslate = 0;
        }

        if (currentTranslate < maxTranslate) {
          currentTranslate = maxTranslate;
        }

        setThumbTranslate(
          currentTranslate
        );
      }

      /* =========================================================
        THUMB PREVIOUS
      ========================================================= */

      thumbPrev?.addEventListener(
        'click',
        () => {

          /*
          * Don't do anything when disabled.
          */
          if (thumbPrev.disabled) {
            return;
          }

          let next =
            currentTranslate + 100;

          if (next > 0) {
            next = 0;
          }

          setThumbTranslate(next);

        }
      );

      /* =========================================================
        THUMB NEXT
      ========================================================= */

      thumbNext?.addEventListener(
        'click',
        () => {

          /*
          * Don't do anything when disabled.
          */
          if (thumbNext.disabled) {
            return;
          }

          const maxTranslate =
            getMaxThumbTranslate();

          let next =
            currentTranslate - 100;

          if (next < maxTranslate) {
            next = maxTranslate;
          }

          setThumbTranslate(next);

        }
      );

      /* =========================================================
        THUMB OVERFLOW
      ========================================================= */

      function checkOverflow() {

        if (!track || !wrapper) {
          updateThumbArrows();
          return;
        }

        /*
        * IMPORTANT:
        *
        * Vertical thumbnail viewport gets
        * the same height as main gallery.
        */
        syncVerticalThumbHeight();

        const container =
          wrapper;

        const isOverflowing =
          isThumbVertical
            ? Math.ceil(track.scrollHeight) >
              Math.ceil(container.clientHeight)

            : Math.ceil(track.scrollWidth) >
              Math.ceil(container.clientWidth);

        wrapper.classList.toggle(
          'is-overflowing',
          isOverflowing
        );

        /*
        * If there is no overflow,
        * reset thumbnail position.
        */
        if (!isOverflowing) {

          currentTranslate = 0;

          setThumbTranslate(0);

          return;
        }

        /*
        * If overflow exists, make sure
        * current translation is still valid.
        */
        clampThumbTranslate();

        /*
        * Update arrow state.
        */
        updateThumbArrows();
      }

      /* =========================================================
        ACTIVE THUMB INTO VIEW
      ========================================================= */

      function scrollThumbIntoView() {

        if (
          !track ||
          !thumbs[currentIndex]
        ) {
          return;
        }

        /*
        * Use wrapper as the viewport.
        */
        const container =
          wrapper;

        const activeThumb =
          thumbs[currentIndex];

        if (
          !container ||
          !activeThumb
        ) {
          return;
        }

        const thumbRect =
          activeThumb.getBoundingClientRect();

        const containerRect =
          container.getBoundingClientRect();

        if (isThumbVertical) {

          /*
          * VERTICAL
          */

          if (
            thumbRect.top <
            containerRect.top
          ) {

            currentTranslate +=
              containerRect.top -
              thumbRect.top;

          }

          else if (
            thumbRect.bottom >
            containerRect.bottom
          ) {

            currentTranslate -=
              thumbRect.bottom -
              containerRect.bottom;

          }

        } else {

          /*
          * HORIZONTAL
          */

          if (
            thumbRect.left <
            containerRect.left
          ) {

            currentTranslate +=
              containerRect.left -
              thumbRect.left;

          }

          else if (
            thumbRect.right >
            containerRect.right
          ) {

            currentTranslate -=
              thumbRect.right -
              containerRect.right;

          }

        }

        /*
        * Keep translation inside bounds
        */
        clampThumbTranslate();
      }

      /* =========================================================
        INITIAL STATE
      ========================================================= */

      /*
      * First sync vertical height.
      */
      syncVerticalThumbHeight();

      /*
      * Then check overflow.
      */
      checkOverflow();

      /*
      * Find existing active image.
      */
      const existingActive =
        mainItems.findIndex(
          item =>
            item.classList.contains(
              'is-active'
            )
        );

      currentIndex =
        existingActive >= 0
          ? existingActive
          : 0;

      /*
      * Set initial thumbnail.
      */
      thumbs.forEach((thumb, i) => {

        thumb.classList.toggle(
          'is-active',
          i === currentIndex
        );

      });

      /*
      * In non-carousel mode,
      * explicitly activate image.
      */
      if (!isCarousel) {

        mainItems.forEach((item, i) => {

          item.classList.toggle(
            'is-active',
            i === currentIndex
          );

        });

      }

      /*
      * Keep initial thumbnail visible.
      */
      scrollThumbIntoView();

      /*
      * Make sure arrow state is correct
      * after initial positioning.
      */
      updateThumbArrows();

      /* =========================================================
        RESIZE OBSERVER
      ========================================================= */

      let galleryResizeObserver = null;

      if (
        mainGallery &&
        typeof ResizeObserver !== 'undefined'
      ) {

        galleryResizeObserver =
          new ResizeObserver(() => {

            syncVerticalThumbHeight();

            checkOverflow();

            /*
            * Re-check active thumbnail after
            * gallery dimensions change.
            */
            scrollThumbIntoView();

            updateThumbArrows();

          });

        galleryResizeObserver.observe(
          mainGallery
        );
      }

      /* =========================================================
        IMAGE LOAD
      ========================================================= */

      mainItems.forEach(item => {

        const images =
          $$('img', item);

        images.forEach(image => {

          if (!image.complete) {

            image.addEventListener(
              'load',
              () => {

                syncVerticalThumbHeight();

                checkOverflow();

                scrollThumbIntoView();

                updateThumbArrows();

              },
              { once: true }
            );

          }

        });

      });

      /* =========================================================
        WINDOW RESIZE
      ========================================================= */

      window.addEventListener(
        'resize',
        () => {

          syncVerticalThumbHeight();

          checkOverflow();

          updateThumbArrows();

        }
      );

      /* =========================================================
        RETURN
      ========================================================= */

      return {
        showSlide: goToMainSlide
      };
    }
    /* -------------------------
       ZOOM
    -------------------------- */
    function initZoom() {
        const zoomElement = section.querySelector('.zoom-enabled');
        if (!zoomElement) return;

        $$('.zoom-container').forEach(container => {
            const img = $('.zoom-image', container);
            if (!img) return;

            if (window.matchMedia("(hover: hover)").matches) {
                container.addEventListener('mousemove', (e) => {
                    const rect = container.getBoundingClientRect();
                    const x = ((e.clientX - rect.left) / rect.width) * 100;
                    const y = ((e.clientY - rect.top) / rect.height) * 100;
                    img.style.transformOrigin = `${x}% ${y}%`;
                    img.style.transform = "scale(2)";
                });

                container.addEventListener('mouseleave', () => {
                    img.style.transform = "scale(1)";
                });
            }
        });
    }

    /* -------------------------
       VARIANTS
    -------------------------- */
    function initVariants(galleryAPI) {
        let subscriptionPrice = null;
        let subscriptionCompare = null;
        const form = $("form[id^='product-form-']");
        if (!form) return;
        const variants = section.dataset.variants ?
            JSON.parse(section.dataset.variants) :
            [];
        const hiddenInput = $("input[name='id']", form);
        const optionGroups = $$('.product-option');
        const addToCartBtn = $('.add-to-cart', form);
        const priceWrapper = $('.product-price');
        let selectedOptions = [];
        let currentVariant = null;
        const initialVariant =
            variants.find(v => v.id == hiddenInput?.value) ||
            variants.find(v => v.available) ||
            variants[0];
        selectedOptions = [
            initialVariant?.option1 || null,
            initialVariant?.option2 || null,
            initialVariant?.option3 || null,
        ];
        function updateUI() {
            optionGroups.forEach((group, index) => {
                $$('.option-value', group).forEach(btn => {

                    const candidateValue = btn.dataset.value;

                    /*
                    * Build the combination progressively.
                    *
                    * Example:
                    *
                    * Color button:
                    *   Black
                    *
                    * We only check:
                    *   option1 = Black
                    *
                    * Size button:
                    *   S
                    *
                    * We check:
                    *   option1 = selected Color
                    *   option2 = S
                    *
                    * We DO NOT check options after the
                    * current option.
                    */

                    const matchingVariants = variants.filter(variant => {

                        // Check previously selected options
                        for (let i = 0; i < index; i++) {
                            if (
                                selectedOptions[i] &&
                                variant[`option${i + 1}`] !== selectedOptions[i]
                            ) {
                                return false;
                            }
                        }

                        // Check the option currently being evaluated
                        if (
                            variant[`option${index + 1}`] !== candidateValue
                        ) {
                            return false;
                        }

                        return true;
                    });

                    /*
                    * No variant exists for this combination
                    */
                    const isUnavailable = matchingVariants.length === 0;

                    /*
                    * Variant exists, but ALL matching variants
                    * are unavailable.
                    */
                    const isSoldOut =
                        matchingVariants.length > 0 &&
                        matchingVariants.every(variant => !variant.available);

                    /*
                    * ACTIVE
                    */
                    btn.classList.toggle(
                        'is-active',
                        candidateValue === selectedOptions[index]
                    );

                    /*
                    * UNAVAILABLE
                    */
                    btn.classList.toggle(
                        'is-unavailable',
                        isUnavailable
                    );

                    /*
                    * SOLD OUT
                    */
                    btn.classList.toggle(
                        'is-soldout',
                        isSoldOut
                    );

                    /*
                    * ------------------------------------
                    * UPDATE PRICE PER OPTION
                    * ------------------------------------
                    *
                    * Pick an available variant first.
                    * If none are available, use the first
                    * matching variant so price still displays.
                    */

                    const priceEl = btn.querySelector('.v_price');
                    const compareEl = btn.querySelector('.v_compare_price');
                    const savingEl = btn.querySelector('.saving');

                    const priceVariant =
                        matchingVariants.find(v => v.available) ||
                        matchingVariants[0];

                    if (priceVariant && priceEl) {

                        priceEl.childNodes[0].nodeValue =
                            formatMoney(priceVariant.price) + ' ';

                        if (compareEl) {

                            if (
                                priceVariant.compare_at_price >
                                priceVariant.price
                            ) {
                                compareEl.textContent =
                                    formatMoney(
                                        priceVariant.compare_at_price
                                    );

                                compareEl.style.display = 'inline';

                            } else {

                                compareEl.style.display = 'none';
                            }
                        }

                        if (savingEl) {

                            if (
                                priceVariant.compare_at_price >
                                priceVariant.price
                            ) {

                                const percent = Math.round(
                                    (
                                        (
                                            priceVariant.compare_at_price -
                                            priceVariant.price
                                        ) * 100
                                    ) /
                                    priceVariant.compare_at_price
                                );

                                savingEl.textContent =
                                    percent + '% OFF';

                                savingEl.style.display = 'block';

                            } else {

                                savingEl.style.display = 'none';
                            }
                        }
                    }
                });
            });
        }
        function autoSelectAvailableOptions(changedIndex) {
            /*
            * Only auto-correct options AFTER the option
            * that the customer changed.
            *
            * Example:
            *
            * Color changed (index 0)
            * → automatically fix Size (index 1)
            */

            for (let index = changedIndex + 1; index < optionGroups.length; index++) {

                const currentValue = selectedOptions[index];

                /*
                * Check whether the currently selected value
                * is available with the current selections.
                */
                const currentVariants = variants.filter(variant => {

                    // Match all options before this option
                    for (let i = 0; i < index; i++) {
                        if (
                            selectedOptions[i] &&
                            variant[`option${i + 1}`] !== selectedOptions[i]
                        ) {
                            return false;
                        }
                    }

                    // Match current option
                    return variant[`option${index + 1}`] === currentValue;
                });

                /*
                * Current value is valid and has an available variant.
                */
                const currentIsAvailable =
                    currentVariants.some(variant => variant.available);

                if (currentIsAvailable) {
                    continue;
                }

                /*
                * Current value is unavailable/sold out.
                *
                * Find the first available option value.
                */
                const buttons = $$(
                    '.option-value',
                    optionGroups[index]
                );

                let nextAvailableValue = null;

                for (const btn of buttons) {

                    const candidateValue = btn.dataset.value;

                    const candidateVariants = variants.filter(variant => {

                        // Match previous selections
                        for (let i = 0; i < index; i++) {
                            if (
                                selectedOptions[i] &&
                                variant[`option${i + 1}`] !== selectedOptions[i]
                            ) {
                                return false;
                            }
                        }

                        // Match candidate value
                        return (
                            variant[`option${index + 1}`] ===
                            candidateValue
                        );
                    });

                    if (
                        candidateVariants.some(
                            variant => variant.available
                        )
                    ) {
                        nextAvailableValue = candidateValue;
                        break;
                    }
                }

                /*
                * Automatically select the first available value.
                */
                if (nextAvailableValue) {
                    selectedOptions[index] = nextAvailableValue;
                }
            }
        }
        function updatePrice() {
            if (!priceWrapper || !currentVariant) return;

            const regular = $('.regular_price', priceWrapper);
            const compare = $('.sale_price', priceWrapper);
            const save = $('.save', priceWrapper);

            // ✅ PRIORITY: subscription > variant
            const finalPrice = subscriptionPrice || currentVariant.price;
            const finalCompare = subscriptionCompare || currentVariant.compare_at_price;

            if (regular) {
                regular.textContent = formatMoney(finalPrice);
            }

            if (compare && save) {
                if (finalCompare > finalPrice) {
                    compare.textContent = formatMoney(finalCompare);
                    compare.style.display = 'inline';

                    const percent = Math.round(
                        ((finalCompare - finalPrice) * 100) / finalCompare
                    );

                    save.textContent = percent + '% OFF';
                    save.style.display = 'inline';
                } else {
                    compare.style.display = 'none';
                    save.style.display = 'none';
                }
            }
        }

        function updateButton() {
            if (!addToCartBtn || !currentVariant) return;
            const finalPrice = subscriptionPrice || currentVariant.price;
            const showBtnPrice = addToCartBtn.hasAttribute('data-btn-price');
            const showBtnIcon = addToCartBtn.hasAttribute('data-btn-svgicon');
            const defaultText = addToCartBtn.dataset.btnText || 'Add to Cart';
            const defaultIcon = addToCartBtn.dataset.btnIcon || `<span class='svgIcon'><svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewbox="0 0 24 24" fill="none">
            <path d="M2 3L2.26491 3.0883C3.58495 3.52832 4.24497 3.74832 4.62248 4.2721C5 4.79587 5 5.49159 5 6.88304V9.5C5 12.3284 5 13.7426 5.87868 14.6213C6.75736 15.5 8.17157 15.5 11 15.5H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z" stroke="currentColor" stroke-width="1.5"></path>
            <path d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z" stroke="currentColor" stroke-width="1.5"></path>
            <path d="M5 6H16.4504C18.5054 6 19.5328 6 19.9775 6.67426C20.4221 7.34853 20.0173 8.29294 19.2078 10.1818L18.7792 11.1818C18.4013 12.0636 18.2123 12.5045 17.8366 12.7523C17.4609 13 16.9812 13 16.0218 13H5" stroke="currentColor" stroke-width="1.5"></path>
            </svg></span>`;
            const soldOutText = addToCartBtn.dataset.btnSoldout || 'Sold Out';
            addToCartBtn.disabled = !currentVariant.available;
            if (!currentVariant.available) {
                addToCartBtn.innerHTML = `<span class="btn_text">${soldOutText}</span>`;
                return;
            }
            if (showBtnPrice) {
                addToCartBtn.innerHTML = `
          <span class="btn_text">${defaultText}</span>${defaultIcon}
          <span class="btn_separator">—</span>
          <span class="btn_price">${formatMoney(finalPrice)}</span>
          `;
            } else {
                addToCartBtn.innerHTML = `<span class="btn_text">${defaultText}</span> ${defaultIcon}`;
            }
        }

        function initAjaxAddToCart() {
          const form = $("form[id^='product-form-']");
          if (!form) return;

          form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const formData = new FormData(form);

            try {
              const {
                CartLinesUpdateEvent,
                CartErrorEvent
              } = await import('@shopify/events');

              /*
              * Create the deferred promise FIRST
              */
              const deferred =
                CartLinesUpdateEvent.createPromise();

              /*
              * Get variant ID
              */
              const variantId =
                formData.get('id');

              const quantity =
                Number(formData.get('quantity') || 1);

              /*
              * Dispatch event BEFORE cart request
              *
              * This is important for the new Horizon
              * cart-drawer-component.
              */
              form.dispatchEvent(
                new CartLinesUpdateEvent({
                  action: 'add',

                  context: 'product',

                  lines: [
                    {
                      merchandiseId: variantId,
                      quantity: quantity
                    }
                  ],

                  promise: deferred.promise
                })
              );

              /*
              * Add to cart
              */
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                  Accept: 'application/json'
                }
              });

              if (!response.ok) {
                throw new Error(
                  'Failed to add product to cart'
                );
              }

              /*
              * Get updated cart
              */
              const ajaxCartResponse =
                await fetch('/cart.js', {
                  headers: {
                    Accept: 'application/json'
                  }
                });

              if (!ajaxCartResponse.ok) {
                throw new Error(
                  'Failed to fetch cart'
                );
              }

              const ajaxCart =
                await ajaxCartResponse.json();

              /*
              * Convert /cart.js response into
              * Shopify Standard Event cart format
              */
              const cart =
                CartLinesUpdateEvent
                  .createCartFromAjaxResponse(
                    ajaxCart
                  );

              /*
              * Resolve the event promise
              */
              deferred.resolve({
                cart
              });

            } catch (error) {

              console.error(
                'AJAX Add to Cart Error:',
                error
              );

              /*
              * Tell Horizon the cart operation failed
              */
              try {

                const {
                  CartErrorEvent
                } = await import('@shopify/events');

                form.dispatchEvent(
                  new CartErrorEvent({
                    error:
                      error?.message ||
                      'Failed to add product to cart',

                    code:
                      'SERVICE_UNAVAILABLE'
                  })
                );

              } catch (eventError) {

                console.error(
                  'Cart Error Event:',
                  eventError
                );

              }
            }
          });
        }
        function updateVariant() {
            subscriptionPrice = null;
            subscriptionCompare = null;
            currentVariant = variants.find(v =>
                (!v.option1 || v.option1 === selectedOptions[0]) &&
                (!v.option2 || v.option2 === selectedOptions[1]) &&
                (!v.option3 || v.option3 === selectedOptions[2])
            );

            if (!currentVariant) return;

            if (hiddenInput) hiddenInput.value = currentVariant.id;

            if (galleryAPI && currentVariant.featured_media) {
                const mediaId = currentVariant?.featured_media?.id;
                if (!mediaId) return;

                const slides = section.querySelectorAll('.gallery-media-item');

                const index = [...slides].findIndex(
                    el => el.dataset.mediaId == mediaId
                );

                if (index !== -1) {
                    galleryAPI.showSlide(index);
                }
            }

            updatePrice();
            updateButton();

            section.dispatchEvent(
                new CustomEvent('variant:change', {
                    detail: {
                        variant: currentVariant
                    }
                })
            );
        }

        function updateSelectedOptionsUI() {
            optionGroups.forEach((group, index) => {
                const selectedDiv = group.querySelector('.selected_optons');
                if (selectedDiv && selectedOptions[index]) {
                    selectedDiv.textContent = selectedOptions[index];
                }
            });
        }

        function initStickyVariantSync(section) {
            const sticky = section.querySelector('.sticky-atc');
            //console.log(sticky)
            if (!sticky) return;
            const priceEl = sticky.querySelector('.sticky-price');
            const compareEl = sticky.querySelector('.sticky-compare');
            const saveEl = sticky.querySelector('.sticky-save');
            const variantEl = sticky.querySelector('.sticky-variant');
            const btn = sticky.querySelector('.sticky-btn');
            let currentVariantData = null;
            /* -------------------------
              VARIANT CHANGE
            -------------------------- */
            section.addEventListener('variant:change', (e) => {
                const variant = e.detail.variant;
                if (!variant) return;
                currentVariantData = variant;
                updateStickyUI(section);
            });
            /* -------------------------
              SEAL SUBSCRIPTION CHANGE
            -------------------------- */
            section.addEventListener('sealsubs:price_update', (e) => {
                if (!e.detail) return;
                const {
                    price,
                    compareAtPrice
                } = e.detail;
                if (!price) return;
                subscriptionPrice = price;
                subscriptionCompare = compareAtPrice || null;
                updateStickyUI(section);
            });

            /* -------------------------
              MAIN UPDATE FUNCTION
            -------------------------- */
            function updateStickyUI(section) {
                const sticky = section.querySelector('.sticky-atc');
                //console.log(section)
                if (!sticky) return;

                if (!currentVariantData) return;

                const variant = currentVariantData;

                // TITLE
                if (variantEl) {
                    variantEl.textContent = [
                        variant.option1,
                        variant.option2,
                        variant.option3
                    ].filter(Boolean).join(' / ');
                }

                // PRICE (🔥 FIXED)
                if (priceEl) {
                    const finalPrice = subscriptionPrice || variant.price;
                    priceEl.textContent = formatMoney(finalPrice);
                }

                // COMPARE + SAVE (🔥 FIXED)
                if (compareEl && saveEl) {

                    const finalCompare = subscriptionCompare || variant.compare_at_price;
                    const finalPrice = subscriptionPrice || variant.price;

                    if (finalCompare > finalPrice) {

                        compareEl.textContent = formatMoney(finalCompare);
                        compareEl.style.display = 'inline';

                        const percent = Math.round(
                            ((finalCompare - finalPrice) * 100) / finalCompare
                        );

                        saveEl.textContent = percent + '% OFF';
                        saveEl.style.display = 'inline';

                    } else {
                        compareEl.style.display = 'none';
                        saveEl.style.display = 'none';
                    }
                }

                // BUTTON
                if (btn) {
                    btn.disabled = !variant.available;
                    const defaultText = btn.dataset.btnText || 'Add to Cart';
                    const soldOutText = btn.dataset.btnSoldout || 'Sold Out';
                    btn.textContent = variant.available ? defaultText : soldOutText;
                }
            }
        }
        optionGroups.forEach((group, index) => {
            $$('.option-value', group).forEach(btn => {

                btn.addEventListener('click', () => {

                    if (btn.classList.contains('is-unavailable')) {
                        return;
                    }

                    /*
                    * Set the option selected by the customer
                    */
                    selectedOptions[index] = btn.dataset.value;

                    /*
                    * Automatically correct any later option
                    * that is now sold out/unavailable.
                    */
                    autoSelectAvailableOptions(index);

                    /*
                    * Update all UI
                    */
                    updateUI();
                    updateSelectedOptionsUI();
                    updateVariant();
                });

            });
        });
        section.addEventListener('sealsubs:price_update', (e) => {
            if (!e.detail) return;
            const {
                price,
                compareAtPrice
            } = e.detail;
            if (!price) return;
            subscriptionPrice = price;
            subscriptionCompare = compareAtPrice || null;
            updatePrice(); // 🔥 force UI update
            updateButton(); // 🔥 sync button
        });
        initStickyVariantSync(section);
        initAjaxAddToCart();
        updateUI();
        updateVariant();
        updateSelectedOptionsUI()
    }

    /* -------------------------
       QUANTITY
    -------------------------- */
    function initQuantity() {
        const wrapper = $('[data-quantity-wrapper]');
        if (!wrapper) return;

        const input = $('.qty-input', wrapper);
        const plus = $('.qty-plus', wrapper);
        const minus = $('.qty-minus', wrapper);

        if (!input) return;

        plus?.addEventListener('click', () => {
            input.value = parseInt(input.value || 1) + 1;
        });

        minus?.addEventListener('click', () => {
            if (input.value > 1) input.value--;
        });
    }

    /* -------------------------
       STICKY
    -------------------------- */
    function initSticky() {
        const sticky = $('.sticky-atc');
        const btn = $('.add-to-cart'); // main button

        if (!sticky || !btn) return;

        const stickyBtn = sticky.querySelector('.sticky-btn');
        const form = $("form[id^='product-form-']");

        if (stickyBtn && form) {
            stickyBtn.addEventListener('click', () => {
                // trigger real form submit
                form.requestSubmit();
            });
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                sticky.classList.toggle('active', !entry.isIntersecting);
            }, {
                threshold: 0
            }
        );
        observer.observe(btn);
    }

    /* -------------------------
       INIT ALL
    -------------------------- */
    const galleryAPI = initGallery();
    initZoom();
    initVariants(galleryAPI);
    initQuantity();
    initSticky();
}

const initializedSections = new Set();

function safeInit(section) {
  if (!section || !section.id) return;
  if (section.dataset.productInitialized === 'true') {
    return;
  }
  section.dataset.productInitialized = 'true';
  initProductScript(section.id);
}
function initResultsProducts() {
  document
    .querySelectorAll("[id^='MainProduct_']")
    .forEach((section) => {
      safeInit(section);
    });
}


/* Initial load */
document.addEventListener("DOMContentLoaded", () => {
  initResultsProducts();
  const resultsList = document.querySelector("#ResultsList");
  if (!resultsList) return;
  let timeout;
  const resultsObserver = new MutationObserver((mutations) => {
    const hasChanges = mutations.some(
      (mutation) =>
        mutation.type === "childList" &&
        (mutation.addedNodes.length ||
          mutation.removedNodes.length)
    );
    if (!hasChanges) return;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      console.log("Results list changed - reinitializing products");
      initResultsProducts();
    }, 100);
  });
  resultsObserver.observe(resultsList, {
    childList: true,
    subtree: true
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_shipping_bar"] && !Shopify.designMode) return;
  try {
    (function () {
    let cartCache = null;
    function getCart() {
      return fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          cartCache = cart;
          return cart;
        });
    }
    function updateFreeShippingBar() {
      getCart().then((cart) => {
        const wrappers = document.querySelectorAll('.cart-progress-wrapper');
        if (!wrappers.length) return;
        // ✅ Calculate NON-subscription total
        let nonSubscriptionTotal = 0;
        cart.items.forEach((item) => {
          // if (!item.selling_plan_allocation) {
          //   nonSubscriptionTotal += item.line_price;
          // }
          nonSubscriptionTotal += item.line_price;
        });

        const rate = Shopify?.currency?.rate || 1;
        const currency = Shopify?.currency?.active || 'USD';

        wrappers.forEach((wrapper) => {
          const bar = wrapper.querySelector('.cart-progress-bar');
          const message = wrapper.querySelector('.goal-message');

          const thresholdUSD = parseInt(wrapper.dataset.threshold || 0);
          if (!thresholdUSD) return;

          const threshold = thresholdUSD * rate;
          const cartTotal = nonSubscriptionTotal;
      
          let progress = (cartTotal / threshold) * 100;
          progress = Math.min(progress, 100);

          let remaining = Math.max(threshold - cartTotal, 0);

          const formatted = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency,
          }).format(remaining / 100);

          // ✅ UI update
          if (bar) bar.style.width = progress + '%';

          if (wrapper) {
            if (progress >= 100) {
              wrapper.classList.add('is-complete');
            } else {
              wrapper.classList.remove('is-complete');
            }
          }

          const template = wrapper.dataset.preGoalMessageTemplate;
          const success = wrapper.dataset.postGoalMessage;

          if (message) {
            if (remaining > 0) {
              message.innerHTML = template.replace('[amount]', formatted);
            } else {
              message.innerHTML = success;
            }
          }
        });
      });
    }

    // ✅ INIT
    document.addEventListener('DOMContentLoaded', updateFreeShippingBar);

    // ✅ Shopify cart events (if supported)
    document.addEventListener('cart:updated', updateFreeShippingBar);
    document.addEventListener('ajaxCart:updated', updateFreeShippingBar);

    // ✅ Fallback (works in ALL themes)
    document.addEventListener('click', function () {
      setTimeout(updateFreeShippingBar, 300);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_slider"] && !Shopify.designMode) return;
  try {
    function initSlider(id) {
    const slider = document.getElementById('slider-' + id);
    if (!slider) return;

    const track = document.getElementById('track-' + id);
    if (!track) return;

    const prev = slider.querySelector('.slider-prev');
    const next = slider.querySelector('.slider-next');
    const dotsWrap = document.getElementById('dots-' + id);

    /* Remove marquee clones if Shopify re-initialises the block. */
    track.querySelectorAll('[data-marquee-clone="true"]').forEach((el) => el.remove());

    const slides = [...track.children];
    const infinite = slider.dataset.infinite === 'true';
    const adaptive = slider.dataset.adaptive === 'true';
    const autoplay = slider.dataset.autoplay === 'true';
    const autoplayMode = slider.dataset.autoplayMode || 'slide';
    const speed = parseInt(slider.dataset.speed, 10) || 3000;

    let index = 0;
    let autoTimer = null;
    let autoAnimation = null;
    let isHovered = false;
    let isDragging = false;
    let marqueeLoopWidth = 0;

    /* -------------------- */

    function getPerRow() {
      const desktop = parseInt(slider.dataset.perDesktop, 10) || 1;
      const tablet = parseInt(slider.dataset.perTablet, 10) || 1;
      const mobile = parseInt(slider.dataset.perMobile, 10) || 1;

      if (window.innerWidth >= 1366) return desktop;
      if (window.innerWidth >= 768) return tablet;
      return mobile;
    }

    /* -------------------- */

    function updateHeight() {
      if (!adaptive || autoplayMode === 'marquee') return;

      const inner = slider.querySelector('.slider-inner');
      const slide = slides[index];

      if (!inner || !slide) return;

      inner.style.height = slide.offsetHeight + 20 + 'px';
    }

    /* -------------------- */

    function updateIndexFromScroll() {
      if (autoplayMode === 'marquee') return;

      const perRow = getPerRow();
      let closest = 0;
      let min = Infinity;

      slides.forEach((slide, i) => {
        const diff = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (diff < min) {
          min = diff;
          closest = i;
        }
      });

      index = Math.floor(closest / perRow) * perRow;
      updateDots();
      updateHeight();
    }

    /* -------------------- */

    function go(i) {
      const perRow = getPerRow();
      const pages = Math.ceil(slides.length / perRow);
      const maxIndex = Math.max(0, (pages - 1) * perRow);

      if (i > maxIndex) i = infinite ? 0 : maxIndex;
      if (i < 0) i = infinite ? maxIndex : 0;

      index = i;

      const slide = slides[index];
      if (!slide) return;

      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth'
      });

      updateDots();
      updateHeight();
    }

    /* -------------------- */

    function buildDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = '';

      const perRow = getPerRow();
      const pages = Math.ceil(slides.length / perRow);

      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.onclick = () => {
          stopAutoplay();
          go(i * perRow);
          if (!isHovered && !isDragging) startAutoplay();
        };
        dotsWrap.appendChild(b);
      }
    }

    /* -------------------- */

    function updateDots() {
      if (!dotsWrap) return;

      const perRow = getPerRow();
      const page = Math.round(index / perRow);

      dotsWrap.querySelectorAll('button').forEach((dot, i) => {
        dot.classList.toggle('active', i === page);
      });
    }

    /* ================================================== */
    /* MARQUEE SETUP                                     */
    /* ================================================== */

    function setupMarquee() {
      if (autoplayMode !== 'marquee' || !slides.length) return;

      slider.classList.add('is-marquee');

      /*
       * A real marquee needs a second copy of the slides.
       * We clone the complete original set and place it directly
       * after the originals. The animation then loops at exactly
       * the width of the first set, so there is no visible jump.
       */
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-marquee-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      /* Disable CSS scroll-snap while the marquee is moving. */
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';

      requestAnimationFrame(() => {
        marqueeLoopWidth = track.scrollWidth / 2;
      });
    }

    /* -------------------- */
    /* NORMAL SLIDE AUTOPLAY */

    function startSlideAutoplay() {
      if (!autoplay || autoplayMode !== 'slide' || isHovered || isDragging) return;

      stopAutoplay();

      autoTimer = setInterval(() => {
        go(index + getPerRow());
      }, speed);
    }

    /* ================================================== */
    /* CONTINUOUS MARQUEE AUTOPLAY                       */
    /* ================================================== */

    function startMarqueeAutoplay() {
      if (!autoplay || autoplayMode !== 'marquee') return;
      if (isHovered || isDragging) return;

      stopMarqueeAutoplay();

      let lastTime = performance.now();

      /*
       * Existing autoplay speed setting is reused.
       * 1000ms = 60px/sec
       * 3000ms = 20px/sec
       * 8000ms = 7.5px/sec
       */
      const pixelsPerSecond = 60000 / speed;

      function animate(currentTime) {
        if (
          !autoplay ||
          autoplayMode !== 'marquee' ||
          isHovered ||
          isDragging
        ) {
          autoAnimation = null;
          return;
        }

        const delta = Math.min(currentTime - lastTime, 50);
        lastTime = currentTime;

        track.scrollLeft += pixelsPerSecond * (delta / 1000);

        /* Seamlessly move back by exactly one complete slide set. */
        if (marqueeLoopWidth > 0 && track.scrollLeft >= marqueeLoopWidth) {
          track.scrollLeft -= marqueeLoopWidth;
        }

        autoAnimation = requestAnimationFrame(animate);
      }

      autoAnimation = requestAnimationFrame(animate);
    }

    /* -------------------- */

    function startAutoplay() {
      if (!autoplay) return;

      if (autoplayMode === 'marquee') {
        startMarqueeAutoplay();
      } else {
        startSlideAutoplay();
      }
    }

    function stopMarqueeAutoplay() {
      if (autoAnimation) {
        cancelAnimationFrame(autoAnimation);
        autoAnimation = null;
      }
    }

    function stopAutoplay() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }

      stopMarqueeAutoplay();
    }

    /* -------------------- */
    /* SCROLL / DOTS */

    let scrollTimer;

    track.addEventListener('scroll', () => {
      if (autoplayMode === 'marquee') return;

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        updateIndexFromScroll();
      }, 80);
    });

    /* -------------------- */
    /* ARROWS */

    if (prev) {
      prev.onclick = () => {
        stopAutoplay();
        go(index - getPerRow());
        if (!isHovered) startAutoplay();
      };
    }

    if (next) {
      next.onclick = () => {
        stopAutoplay();
        go(index + getPerRow());
        if (!isHovered) startAutoplay();
      };
    }

    /* -------------------- */
    /* HOVER PAUSE */

    slider.addEventListener('mouseenter', () => {
      isHovered = true;
      stopAutoplay();
    });

    slider.addEventListener('mouseleave', () => {
      isHovered = false;
      startAutoplay();
    });

    /* -------------------- */
    /* DRAG */

    let isDown = false;
    let startX = 0;
    let dragStartScrollLeft = 0;

    track.addEventListener('pointerdown', (e) => {
      isDown = true;
      isDragging = true;
      startX = e.pageX;
      dragStartScrollLeft = track.scrollLeft;
      stopAutoplay();

      if (track.setPointerCapture) {
        track.setPointerCapture(e.pointerId);
      }
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;

      const walk = e.pageX - startX;
      track.scrollLeft = dragStartScrollLeft - walk;

      if (autoplayMode === 'marquee' && marqueeLoopWidth > 0) {
        if (track.scrollLeft >= marqueeLoopWidth) {
          track.scrollLeft -= marqueeLoopWidth;
          dragStartScrollLeft -= marqueeLoopWidth;
        } else if (track.scrollLeft < 0) {
          track.scrollLeft += marqueeLoopWidth;
          dragStartScrollLeft += marqueeLoopWidth;
        }
      }
    });

    function endDrag() {
      if (!isDown) return;

      isDown = false;
      isDragging = false;

      if (autoplayMode === 'marquee' && marqueeLoopWidth > 0) {
        if (track.scrollLeft >= marqueeLoopWidth) {
          track.scrollLeft -= marqueeLoopWidth;
        } else if (track.scrollLeft < 0) {
          track.scrollLeft += marqueeLoopWidth;
        }
      }

      startAutoplay();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);

    /* -------------------- */
    /* INIT */

    if (autoplayMode === 'marquee') {
      setupMarquee();
    }

    buildDots();
    updateDots();
    updateHeight();

    requestAnimationFrame(() => {
      if (autoplayMode === 'marquee') {
        marqueeLoopWidth = track.scrollWidth / 2;
        track.scrollLeft = 0;
      }

      startAutoplay();
    });

    /* -------------------- */
    /* RESIZE */

    let resizeTimer;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        stopAutoplay();

        if (autoplayMode === 'marquee') {
          marqueeLoopWidth = track.scrollWidth / 2;
        }

        buildDots();
        updateDots();
        updateHeight();

        if (!isHovered && !isDragging) {
          startAutoplay();
        }
      }, 150);
    });
  }

  /* ---------- INIT ---------- */

  document.querySelectorAll('.slider_block').forEach((el) => {
    initSlider(el.dataset.id);
  });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.slider_block').forEach((el) => {
      initSlider(el.dataset.id);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_tabs"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.tab-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;
      const wrapper = btn.closest('.tabs_collection');
      // remove active
      wrapper.querySelectorAll('.tab-btn').forEach((b) => b.classList.remove('active'));
      wrapper.querySelectorAll('.tab-content').forEach((c) => c.classList.remove('active'));
      // add active
      btn.classList.add('active');
      wrapper.querySelector('#' + tabId).classList.add('active');
    });
  });
  document.querySelectorAll('.tab-content').forEach((item) => {
    const productCart = item.querySelectorAll('.product-card');
    productCart.forEach((button) => {
      button.addEventListener('click', () => {
         button.classList.toggle('is-selected');
        const section = button.querySelector(['[data-section]']);
        const paretDiv = button.closest('.tab-content');
        const bundle = paretDiv.querySelectorAll('[data-bundle]')[0];
        //console.log(bundle);
        if (!bundle) return;
        // get all selected products inside this bundle
        const selectedProducts = paretDiv.querySelectorAll('.is-selected');
        //console.log(selectedProducts);
        let totalPrice = 0;
        selectedProducts.forEach((el) => {
          const price = parseInt(el.dataset.price || 0);
          totalPrice += price;
        });
        const dataEl = bundle.querySelector('.bundle-data');
        
          const items = [];
          selectedProducts.forEach((el) => {
            const id = parseInt(el.dataset.variantId);
            const available = el.dataset.available !== 'false'; // optional
            if (id) {
              items.push({
                id: id,
                available: available
              });
            }
          });
          // 🔥 THIS is the correct way
          dataEl.dataset.items = JSON.stringify(items);
        const shopCurrency = section.dataset.currency;
        const shopLocale = section.dataset.locale;
        const formatMoney = (cents) => {
          const rate = Shopify?.currency?.rate || 1;
          const converted = cents / 100;
          return new Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active,
          }).format(converted);
        };
        const discount = parseFloat(bundle.dataset.discount || 0);
        //console.log(discount);
        const discountAmount = Math.round((totalPrice * discount) / 100);
        const finalPrice = Math.round(totalPrice - discountAmount);
        //console.log(finalPrice);
        // update UI (ONLY these 3 things)
        const bundlePrice = bundle.querySelector('.bundle_price');
        //console.log(bundlePrice);
        if (bundlePrice) {
          bundlePrice.textContent = formatMoney(Math.round(totalPrice));
        }
        const saveBundle = bundle.querySelector('.saveBundle');
        
        //console.log(saveBundle);
        if (saveBundle) {
          if(selectedProducts.length >= 2){
          saveBundle.textContent = formatMoney(finalPrice);
          }else{
          saveBundle.textContent = formatMoney(totalPrice);
          }
        }
        const saveEl = bundle.querySelector('.youSave');
        if (saveEl) {
          saveEl.textContent = `You save ${formatMoney(discountAmount)} (${discount}% OFF)`;
        }
        const AddButton = bundle.querySelector('.bundle-add-btn');
        if(selectedProducts.length >= 2){
          AddButton.classList.remove('disabled')
        }else{
          AddButton.classList.add('disabled')
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_timer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    function initTimers() {
      document.querySelectorAll('.offer-timer').forEach((timer) => {
        if (timer.dataset.init) return;
        timer.dataset.init = 'true';
        const start = new Date(timer.dataset.start).getTime();
        const end = new Date(timer.dataset.end).getTime();
        const daysEl = timer.querySelector('.days');
        const hoursEl = timer.querySelector('.hours');
        const minutesEl = timer.querySelector('.minutes');
        const secondsEl = timer.querySelector('.seconds');
        function updateTimer() {
          const now = new Date().getTime();
          if (now < start) {
            timer.style.display = 'none';
            return;
          }
          if (now > end) {
            timer.style.display = 'none';
            return;
          }
          timer.style.display = 'block';
          const distance = end - now;
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((distance / (1000 * 60)) % 60);
          const seconds = Math.floor((distance / 1000) % 60);
          daysEl.textContent = String(days).padStart(2, '0');
          hoursEl.textContent = String(hours).padStart(2, '0');
          minutesEl.textContent = String(minutes).padStart(2, '0');
          secondsEl.textContent = String(seconds).padStart(2, '0');
        }
        updateTimer();
        setInterval(updateTimer, 1000);
      });
    }
    initTimers();
    const observer = new MutationObserver(() => {
      initTimers();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_video"] && !Shopify.designMode) return;
  try {
    function setupVideoBlock(container) {
  var wrappers = container.querySelectorAll('.video_block__media');

  wrappers.forEach(function (wrapper) {

    var video = wrapper.querySelector('video');
    var playButton = wrapper.querySelector('.video_block__play');
    var muteButton = wrapper.querySelector('.video_block__mute');

    if (!video || !playButton || !muteButton) {
      return;
    }

    /* Prevent duplicate events */
    if (video.dataset.controlsReady === 'true') {
      return;
    }

    video.dataset.controlsReady = 'true';

    /*
     * PLAY / PAUSE
     */
    playButton.addEventListener('click', function (event) {

      event.preventDefault();
      event.stopPropagation();

      if (video.paused) {
        video.play().catch(function (error) {
          console.log('Video play error:', error);
        });
      } else {
        video.pause();
      }

    });


    /*
     * MUTE / UNMUTE
     */
    muteButton.addEventListener('click', function (event) {

      event.preventDefault();
      event.stopPropagation();

      video.muted = !video.muted;

      updateMuteState();

    });


    /*
     * VIDEO PLAY EVENT
     */
    video.addEventListener('play', function () {
      wrapper.classList.add('is-playing');
    });


    /*
     * VIDEO PAUSE EVENT
     */
    video.addEventListener('pause', function () {
      wrapper.classList.remove('is-playing');
    });


    /*
     * VIDEO MUTE EVENT
     */
    video.addEventListener('volumechange', function () {
      updateMuteState();
    });


    /*
     * INITIAL PLAY STATE
     */
    if (!video.paused) {
      wrapper.classList.add('is-playing');
    } else {
      wrapper.classList.remove('is-playing');
    }


    /*
     * INITIAL MUTE STATE
     */
    updateMuteState();


    function updateMuteState() {

      if (video.muted || video.volume === 0) {

        wrapper.classList.remove('is-unmuted');

        muteButton.setAttribute(
          'aria-label',
          'Unmute video'
        );

      } else {

        wrapper.classList.add('is-unmuted');

        muteButton.setAttribute(
          'aria-label',
          'Mute video'
        );

      }

    }

  });
}


/*
 * INITIALIZE
 */
function initVideoBlocks() {
  setupVideoBlock(document);
}


/*
 * IMPORTANT:
 * Actually run the function.
 */
if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    initVideoBlocks
  );

} else {

  initVideoBlocks();

}


/*
 * SHOPIFY THEME EDITOR
 */
document.addEventListener(
  'shopify:section:load',
  function (event) {
    setupVideoBlock(event.target);
  }
);


/*
 * SHOPIFY BLOCK SELECT
 */
document.addEventListener(
  'shopify:block:select',
  function (event) {
    setupVideoBlock(event.target);
  }
);
  } catch(e) { console.error(e); }
})();

})();
